import { ArrowRight24 } from '@carbon/icons-react';
import { Button } from 'carbon-components-react';

type CtaProps = {
  value: string;
  handleClick: () => void;
  kind?: any;
  iconType?: string;
  classes?: string;
};

const Cta = ({ value, handleClick, kind, classes }: CtaProps) => {
  return (
    <>
      <Button kind={kind} className={classes} onClick={handleClick}>
        {value}
        <ArrowRight24 className="cta-icon" />
      </Button>
    </>
  );
};

export default Cta;
